import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, MapPin, Phone, ArrowRight } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300" data-id="element-61">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-10 pt-16 pb-12" data-id="element-62">
        {/* Top Section - Logo & Newsletter (2 Columns) */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-12 items-center" data-id="element-63">
          {/* Column 1 - Logo & Description */}
          <div className="text-center lg:text-left" data-id="element-64">
            <Link to="/" className="inline-block mb-4 group" data-id="element-65">
              <img src="https://cdn.magicpatterns.com/uploads/37LqrxU35PwjhXWE2X2bUm/logo_(1)_(1).jpg" alt="RaceLookup Logo" className="h-12 w-auto object-contain rounded-xl" data-id="element-66" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-67">
              The world's largest directory of running events. Discover races,
              connect with clubs, and achieve your running goals.
            </p>
          </div>

          {/* Column 2 - Newsletter Signup */}
          <div data-id="element-68">
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-69">Stay Updated</h3>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed" data-id="element-70">
              Get race alerts, training tips, and exclusive deals delivered to
              your inbox.
            </p>
            <form className="flex gap-2" data-id="element-71">
              <input type="email" placeholder="Enter your email" className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-[#01AAE7] text-white placeholder:text-gray-500 text-sm transition-all" data-id="element-72" />
              <button type="submit" className="px-5 py-2.5 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-lg hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl flex items-center gap-2 text-sm" data-id="element-73">
                <span className="hidden sm:inline" data-id="element-74">Subscribe</span>
                <ArrowRight className="h-4 w-4" data-id="element-75" />
              </button>
            </form>
          </div>
        </div>

        {/* 4 Column Links Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12" data-id="element-76">
          {/* Events, Clubs & Programs */}
          <div data-id="element-77">
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-6" data-id="element-78">
              Events, Clubs & Programs
            </h3>
            <ul className="space-y-3" data-id="element-79">
              <li data-id="element-80">
                <Link to="/events" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-81">
                  Search Events
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/clubs" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-83">
                  Search Clubs
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="/brand-ambassador" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-85">
                  Brand Ambassador Program
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="/pacer-program" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-87">
                  Pacer Program
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/store" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-89">
                  Online Store
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/travel-deals" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-91">
                  Travel Deals
                </Link>
              </li>
            </ul>
          </div>

          {/* Services & Merchandise */}
          <div data-id="element-92">
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-6" data-id="element-93">
              Services & Merchandise
            </h3>
            <ul className="space-y-3" data-id="element-94">
              <li data-id="element-95">
                <Link to="/sign-in" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-96">
                  List Events
                </Link>
              </li>
              <li data-id="element-97">
                <Link to="/sign-in" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-98">
                  List Clubs
                </Link>
              </li>
              <li data-id="element-99">
                <Link to="/registration-features" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-100">
                  Registration Features
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/pricing" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-102">
                  Pricing
                </Link>
              </li>
              <li data-id="element-103">
                <Link to="/pace-teams" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-104">
                  Pace Teams
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect with Us */}
          <div data-id="element-105">
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-6" data-id="element-106">
              Connect with Us
            </h3>
            <ul className="space-y-3" data-id="element-107">
              <li data-id="element-108">
                <Link to="/contact" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-109">
                  Contact
                </Link>
              </li>
              <li data-id="element-110">
                <a href="https://facebook.com/RaceLookup" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm flex items-center gap-2" data-id="element-111">
                  <Facebook className="h-4 w-4" data-id="element-112" />
                  Facebook @RaceLookup
                </a>
              </li>
              <li data-id="element-113">
                <a href="https://twitter.com/RaceLookup" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm flex items-center gap-2" data-id="element-114">
                  <Twitter className="h-4 w-4" data-id="element-115" />
                  Twitter @RaceLookup
                </a>
              </li>
              <li data-id="element-116">
                <a href="https://instagram.com/racelookup" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm flex items-center gap-2" data-id="element-117">
                  <Instagram className="h-4 w-4" data-id="element-118" />
                  Instagram @racelookup
                </a>
              </li>
              <li data-id="element-119">
                <Link to="/blog" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-120">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* About Us */}
          <div data-id="element-121">
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-6" data-id="element-122">
              About Us
            </h3>
            <ul className="space-y-3" data-id="element-123">
              <li data-id="element-124">
                <Link to="/about" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-125">
                  About
                </Link>
              </li>
              <li data-id="element-126">
                <Link to="#" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-127">
                  Mission
                </Link>
              </li>
              <li data-id="element-128">
                <Link to="#" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-129">
                  Board of Directors
                </Link>
              </li>
              <li data-id="element-130">
                <Link to="#" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-131">
                  Partners
                </Link>
              </li>
              <li data-id="element-132">
                <Link to="#" className="text-gray-400 hover:text-[#01AAE7] transition-colors text-sm" data-id="element-133">
                  Press
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar - 2 Columns */}
        <div className="border-t border-gray-800 pt-8" data-id="element-134">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-135">
            {/* Column 1 - Copyright */}
            <div className="text-sm text-gray-500 text-center md:text-left" data-id="element-136">
              © {currentYear} RaceLookup. All rights reserved.
            </div>

            {/* Column 2 - Legal Links */}
            <div className="flex flex-wrap justify-center md:justify-end gap-6 text-sm" data-id="element-137">
              <Link to="#" className="text-gray-500 hover:text-[#01AAE7] transition-colors" data-id="element-138">
                Privacy Policy
              </Link>
              <Link to="#" className="text-gray-500 hover:text-[#01AAE7] transition-colors" data-id="element-139">
                Terms of Service
              </Link>
              <Link to="#" className="text-gray-500 hover:text-[#01AAE7] transition-colors" data-id="element-140">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}